import React, { useEffect, useState } from "react";
import { AppRouter } from "./routes/AppRouter.jsx";
import { useTranslatedData } from "./data/data.jsx";
import "./App.css";
import { AuthContext } from "./context/AuthContext.jsx";
import { getLocalUser } from "./utils/authUtils.js";
import ReactGA from "react-ga4";

function App() {
  ReactGA.initialize("G-4G4FMWKV51", { debug: true });
  const data = useTranslatedData(); // esto ejecuta t() y devuelve los textos traducidos

  let isLoged = getLocalUser();
  const [userLog, setUserLog] = useState(isLoged);

  useEffect(() => {
    setUserLog(isLoged);
  }, []);

  // generateTranslationJSON(data);

  return (
    <div className="mdl-app">
      <AuthContext.Provider value={{ userLog, setUserLog }}>
        <AppRouter data={data} />
      </AuthContext.Provider>
    </div>
  );
}

export default App;

/**
 * Devuelve el array de traducciones
 */

const generateTranslationJSON = (data) => {
  const translations = {};

  data.forEach((item, index) => {
    const sectionKey = `article${index + 1}`;

    // Creamos la entrada base
    translations[sectionKey] = {
      title: item.title,
    };

    // Agregamos los ejercicios si existen
    if (item.exercices && Array.isArray(item.exercices)) {
      item.exercices.forEach((exercise, i) => {
        translations[sectionKey][`exercise${i + 1}`] = {
          title: exercise.title || "",
          typeName: exercise.typeName || "",
        };
      });
    }
  });

  console.log(JSON.stringify(translations, null, 2));
};
